import type { FC } from 'react';
import React from 'react';
import { Box, keyframes, styled } from '@withjoy/joykit';
import { ChevronDown } from '@withjoy/joykit/icons';
import { pxToRem } from '@withjoy/joykit/theme';
import chroma from 'chroma-js';
import { useColorPaletteProvider } from '@apps/guest/packages/layout-engine/layouts/ColorPaletteProvider/ColorPaletteProvider';

const chevronBounce = keyframes`
  0%, 100% {
    transform: translate(-50%, 50%);
  }
  50% {
    transform: translate(-50%, calc(50% + 8px));
  }
`;

const BouncingChevronContainer = styled(Box)`
  animation: ${chevronBounce} 2s ease-in-out infinite;
`;

export const BouncingChevron: FC = () => {
  const { pageColor, pageFontColor } = useColorPaletteProvider();

  return (
    <BouncingChevronContainer
      position="absolute"
      bottom={0}
      left="50%"
      zIndex={2}
      width={pxToRem(40)}
      height={pxToRem(40)}
      borderRadius="50%"
      display="flex"
      alignItems="center"
      justifyContent="center"
      backgroundColor={pageFontColor}
      border="1px solid"
      borderColor={pageColor ? chroma(pageColor).alpha(0.7).css() : undefined}
      opacity={0.8}
    >
      <ChevronDown
        size={24}
        color={pageColor}
      />
    </BouncingChevronContainer>
  );
};
